<template>
    <div class="white-container mb-30px">
        <div v-if="listOfInputs">
            <div v-for="(listOfInput, index) in listOfInputs" :key="index">
                <h2>{{ listOfInput.title }}</h2>
                <div class="paragraph" v-if="listOfInput.comment">{{ listOfInput.comment }}</div>
                <div class="row">
                    <div v-for="(input, subindex) in listOfInput.inputs" :key="subindex"
                        class="d-flex col-50 align-end mt-20px">
                        <div class="col-20 no-shrink"><img :src="input.img" class="distance-calculator-icon" /></div>
                        <div class="w-100">
                            <label class="label-calculators" v-html="input.label"></label>
                            <div class="position-relative">
                                <input type="number" class="calculator-input-square w-100" style="padding-right: 70px;"
                                    v-model="results[input.label]" @input="addFactor(input.label, input.factor);$emit('update:modelValue', results)">
                                <div v-if="input.unit" class="small-input-unit" v-html="input.unit"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            results: {
                factor:{
                    
                }
            }
        }
    },
    methods:{
        addFactor(label, factor){
            this.results.factor[label]=factor
        }
    },
    props: {
        listOfInputs: Object,
        modelValue: Object
    },
    watch: {
        modelValue(newVal) {
            this.results = newVal;
        }
    }
}
</script>
<style scoped>
.white-container h2 {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.margin-adaptation {
    margin-top: -50px;
    margin-bottom: 80px;
}
.col-20{
    width:20%;
}
.small-input-unit {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
    color: var(--text-color);
    font-family: var(--font);
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px;
    /* 141% */
}

.distance-calculator-icon {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
}

@media screen and (max-width: 1500px) {
    .white-container h2 {
        font-size: 45px !important;
    }
    .label-calculators{
    font-size: 28px;
  }
}

@media screen and (max-width: 1300px) {
    .white-container h2 {
        font-size: 30px !important;
    }
    .label-calculators{
        font-size: 23px;
    }
}
@media screen and (max-width: 900px) {
    .label-calculators{
        margin-top:10px;
        display: flex;
        align-items: center;
    }
}
@media screen and (max-width: 750px) {
    .col-50 {
        width: 100%;
    }
}

@media screen and (max-width: 600px) {
    .white-container h2 {
        font-size: 25px;
    }
}

@media screen and (max-width: 600px) {
    .white-container h2 {
        font-size: 25px;
    }

}
</style>